import dayjs from 'dayjs';

export function isCampaignActive(start, end, now = dayjs()) {
    if (!start) return false;
    const current = dayjs(now);
    const begins = dayjs(start);
    const ends = end ? dayjs(end) : null;
    return current.isValid() && begins.isValid() && !current.isBefore(begins)
        && (!ends || (ends.isValid() && !current.isAfter(ends)));
}
